import {
  compose,
  branch,
  withHandlers,
  renderNothing
} from 'recompose';
import { connect } from 'react-redux';
import ContentQuestion from './../../shared/publish-content/content-question';
import {
  businessSelector
} from '../../../../state/modules/business';
import {
  businessActions
} from '../../../../state/modules/business'
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  selectedContent: state.business.content.selectedContent,
  contentError: state.business.content.error,
  contentQuestions: state.business.content.contentQuestions,
  saveQuestionSuccess: state.business.content.saveQuestionSuccess,
  libraryRouteRoot: routes.app.library,
  isFetchingContent: state.business.content.isFetching
});

const mapDispatchToProps = (dispatch) => ({
  businessLibraryGetContent: bindActionCreators(businessActions.business.content.getById, dispatch),
  businessLibraryResetSelectedContent: bindActionCreators(businessActions.business.content.resetSelectedContent, dispatch),
  businessLibraryGetContentQuestions: bindActionCreators(businessActions.business.content.getContentQuestions, dispatch),
  businessLibraryDeleteContentQuestion: bindActionCreators(businessActions.business.content.deleteQuestion, dispatch),
  businessLibrarySaveContent: bindActionCreators(businessActions.business.content.saveContent, dispatch),
  businessLibrarySaveQuestion: bindActionCreators(businessActions.business.content.saveQuestion, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business }) => !business,
    renderNothing
  ),
  withHandlers({
    getContent: ({ business, businessLibraryGetContent }) => (contentId) => {
      businessLibraryGetContent(business.id, contentId)
    },
    resetSelectedContent: ({ business, businessLibraryResetSelectedContent }) => () => {
      businessLibraryResetSelectedContent(business.id)
    },
    getContentQuestions: ({ business, businessLibraryGetContentQuestions }) => (contentId) => {
      businessLibraryGetContentQuestions(business.id, contentId)
    },
    deleteContentQuestion: ({ business, businessLibraryDeleteContentQuestion }) => (contentId, questionId) => {
      businessLibraryDeleteContentQuestion(business.id, contentId, questionId)
    },
    saveContent: ({ business, businessLibrarySaveContent }) => (content, nextRoute) => {
      businessLibrarySaveContent(business.id, content, nextRoute)
    },
    saveQuestion: ({ business, businessLibrarySaveQuestion }) => (questionData) => {
      businessLibrarySaveQuestion(business.id, questionData)
    }
  })
)(ContentQuestion);


// WEBPACK FOOTER //
// ./src/containers/pages/app/business-library/content-question.js